export const amountTypes = {
  percentage: 0,
  amount: 1
}

export const toNumber = (value) => isNaN(value) || value === null || value === undefined || typeof (value) === 'boolean' ? 0 : value

export const formatDiff = ({ value, formatter = x => x }) => value < 0 ? formatter(value) : `+${formatter(value)}`

export const rollDice = (probability = 0.5) => Math.random() <= probability
